import { apiGet, apiPostPut, apiDelete } from "./api_methods";
import { RECRUITER_RESUME_SCORES_BASE } from "./endpoints";

/**
 * Creates/Processes Resume Scores for a Specific JD (POST /v1/recruiter/resume-scores/create/:jdId)
 * @param {string} jdId - Job Description ID
 * @param {Object} body - Body content. (resumes, isSave, isSort, version, createdBy)
 * @returns {Promise<{ body, status }>}
 */
export async function createResumeScores(jdId, body) {
  return apiPostPut(
    body,
    `${RECRUITER_RESUME_SCORES_BASE}/create/${jdId}`,
    "POST",
  );
}

/**
 * Fetches paginated list of resume scores associated with a given JD (GET /v1/recruiter/resume-scores/jd/:jdId)
 * @param {string} jdId - Job Description ID
 * @param {Object} params - Query parameters (skip, limit)
 * @returns {Promise<{ body, status }>}
 */
export async function getResumeScoresByJd(jdId, params = {}) {
  const q = {};
  if (params.skip != null) q.skip = params.skip;
  if (params.limit != null) q.limit = params.limit;

  const query = new URLSearchParams(q).toString();
  const path = query
    ? `${RECRUITER_RESUME_SCORES_BASE}/jd/${jdId}?${query}`
    : `${RECRUITER_RESUME_SCORES_BASE}/jd/${jdId}`;
  return apiGet(path);
}

/**
 * Retrieves a specific resume score document by its DB ID (GET /v1/recruiter/resume-scores/:id)
 * @param {string} id - Resume Score ID
 * @returns {Promise<{ body, status }>}
 */
export async function getResumeScoreById(id) {
  return apiGet(`${RECRUITER_RESUME_SCORES_BASE}/${id}`);
}

/**
 * Partially updates an existing resume score document (PUT /v1/recruiter/resume-scores/:id)
 * @param {string} id - Resume Score ID
 * @param {Object} body - Fields to update
 * @returns {Promise<{ body, status }>}
 */
export async function updateResumeScore(id, body) {
  return apiPostPut(body, `${RECRUITER_RESUME_SCORES_BASE}/${id}`, "PUT");
}

/**
 * Soft-deletes a resume score by its ID (DELETE /v1/recruiter/resume-scores/:id)
 * @param {string} id - Resume Score ID
 * @returns {Promise<{ body, status }>}
 */
export async function deleteResumeScore(id) {
  return apiDelete(`${RECRUITER_RESUME_SCORES_BASE}/${id}`);
}
